import { render, staticRenderFns } from "./UserFeed.vue?vue&type=template&id=53fe2ca3&scoped=true"
import script from "./UserFeed.vue?vue&type=script&lang=js"
export * from "./UserFeed.vue?vue&type=script&lang=js"
import style0 from "./UserFeed.vue?vue&type=style&index=0&id=53fe2ca3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fe2ca3",
  null
  
)

export default component.exports